/* eslint-disable react/jsx-no-target-blank */
import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./portfolio.css";
import { themeContext } from "../../Context";
import over from "../image/over.png";
import croma from "../image/croma.png";
import geek from "../image/geek.png";
import you from "../image/you.png";
export const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio">
      <span className="p-title" style={{ color: darkMode ? "white" : "" }}>
        Projects
      </span>
      <span
        style={{ color: "crimson", fontSize: "17px", fontWeight: "bolder" }}
      >
        Recent Projects
      </span>
      <Swiper
        // spaceBetween={50}
        slidesPerView={2}
        // grabCursor={true}
        modules={[Pagination]}
        // autoplay={{delay:5000}}
        pagination={{ clickable: true }}
        className="portfolio-slider"
      >
               <SwiperSlide>
          <img src={geek} alt="" />
          <div className="port-describe">
            <div className="portfolio-name">Memories </div>
            <span>
              Memories - A platform for storing and sharing cherished memories,
              whether they be in the form of photos, videos, or written stories.
            </span>
            <ul>
              <span className="crim">Features</span>
              <li>JWT Sign-in/Sign-up</li>
              <li>Pagination for browsing through memories</li>
              <li>Form for adding new memories,Comments section for interaction and sharing thoughts</li>  
              <li>Recommended posts based on user preferences ,Duration tracking for each memory</li>
            </ul>
            <span>
              <p className="crim">Tech Stack </p>
              <span>
                ReactJs|Css|NodeJs|MUI|redux
                toolkit|mongoDb|ExpressJs
              </span>
            </span>
          </div>
          <div className="port-button">
            <a
              href="https://memories-travel.netlify.app"
              style={{ textDecoration: "none" }}
              target="_blank"
          
            >
              {" "}
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                See This Live
              </buttton>
            </a>
            <a
              href="https://github.com/amananshul/Memories-Client-side"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              {" "}
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                View Code
              </buttton>
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={over} alt="" />
          <div className="portfolio-names">Over-stock Clone</div>
          <div className="port-describe">
            <span>
              An international E-commerce web-site clone for shopping various
              items categories like clothing furniture lightening sports
              jwellery gaming electronics Accesories etc.{" "}
            </span>
            <ul>
              <span className="crim">Features</span>
              <li>Social Sign-in/Sign-up</li>
              <li>Responsive-for different Devices</li>
              <li>Working Add to Cart page</li>
              <li>Filters and sort methods are added for different items avaliable in cart. </li>
              <li>User Payment Gateway</li>
            </ul>
            <span>
              <p className="crim">Tech Stack </p>
              <span> HTML | CSS | Javascript | Dom manipulation</span>
            </span>
          </div>
          <div className="port-button">
            <a
              href="https://over-stock.netlify.app/"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              {" "}
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                See This Live
              </buttton>
            </a>
            <a
              href="https://github.com/amananshul/Over_Stock_project"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                View Code
              </buttton>
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={croma} alt="croma" />
          <div className="port-describe">
            <div className="portfolio-name">Croma Clone</div>
            <span>
              An indianl E-commerce web-site Croma popular for shopping speakers
              and television, phoneCase and covers ,clothing Gaming and several
              other product.{" "}
            </span>
            <ul>
              <span className="crim">Features</span>
              <li> Login-in/Sign-up Functionality Added</li>
              <li>Pagination for loading pages and calling api</li>
              <li>Responsive-for different Devices</li>
              <li>Rest Api are used for real time database updates</li>
              <li>Filters and sort methods are added for different items avaliable in cart. </li>
              <li>Dynamic layout with dropdown opening in hover</li>
            </ul>
            <span>
              <p className="crim">Tech Stack </p>
              <span> HTML | CSS | Javascript | Dom manipulation</span>
            </span>
          </div>
          <div className="port-button">
            <a
              href="https://croma-clone.netlify.app/"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              {" "}
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                See This Live
              </buttton>
            </a>
            <a
              href="https://github.com/abhinavBisht94/croma-clone-web16-u3"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              {" "}
              <buttton
                className="button s-button"
                style={{ display: "inline" }}
              >
                View Code
              </buttton>
            </a>
          </div>
        </SwiperSlide>
 
      </Swiper>
    </div>
  );
};
